import forrest from "@onefront/forrestjs-core";
import reactRoot from "@onefront/forrestjs-react-root";

import { servicePushID } from "./service-pushid";
import { serviceVapor } from "./service-vapor";
import { serviceNotistack } from "./service-notistack";
import { serviceAxios } from "./service-axios";
import { serviceAuth } from "./service-auth";
import { serviceRest } from "./service-rest";
import { serviceLayout } from "./service-layout";
import { serviceEmbed } from "./service-embed";
import { serviceI18N } from "./service-i18n";
import { serviceGainsight } from "./service-gainsight";
// @TODO: those should be external components
//        maybe even Webpack federated components that are distributed
//        via CDN and dynamically loaded by the Launchpad)
import { serviceAppSwitch } from "./service-app-switch";

console.warn(
  `'customerSelector' is removed from '@onefront/react-sdk'. You can import it manually form '@onefront/components-customer-selector'.`
);

console.warn(
  `'companySelector' is removed from '@onefront/react-sdk. You can import it manually form '@onefront/components-company-selector'.`
);

// Export simple booting interface
export const OneFront = {
  run: ({
    settings = {},
    services = [],
    features = [],
    ...otherConfig
  } = {}) => {
    const one = settings.one;
    const appId = one.login.target.params[1].split("=")[1];
    const mergedSettings = {
      ...one,
      appId
    };
    settings.one = mergedSettings;
    return forrest.run({
      ...otherConfig,
      settings,
      services: [
        reactRoot,
        servicePushID,
        serviceVapor,
        serviceNotistack,
        serviceAxios,
        serviceAuth,
        serviceRest,
        serviceLayout,
        serviceEmbed,
        serviceI18N,
        serviceAppSwitch,
        serviceGainsight,
        ...services
      ],
      features
    });
  }
};

export { useGetConfig, useGetContext } from "@onefront/forrestjs-react-root";

// Export top level APIs:
export { generatePushID, usePushID } from "./service-pushid";
export { useAxios, useTargetUrl, useJumpUrl, useProxy } from "./service-axios";
export {
  useRequest,
  useGet,
  useDelete,
  usePost,
  usePut,
  useQuery,
  useMutation
} from "./service-rest";
export { useAuth, useTokenData } from "./service-auth";
export {
  useLayout,
  useMenu,
  useHideSideNav,
  useSideNavIsVisible,
  withHiddenSideNav,
  withSideNav
} from "./service-layout";
export {
  EMBED_CLOSE_MSG,
  EMBED_SELECT_MSG,
  EMBED_READY_MSG,
  useHostPage,
  useEmbedPage,
  useEmbedDrawer,
  useEmbedDrawerSelect,
  EmbedIFrame
} from "./service-embed";
export { useSnackbar, NotistackWrapper } from "./service-notistack";
export {
  useTranslation,
  withTranslation,
  Translation,
  Trans,
  registryParse,
  registryRequest
} from "./service-i18n";
export { useBrowserStorage } from "./utils/use-browser-storage";

// EXPERIMENTAL: Export single services
export { default as forrest } from "@onefront/forrestjs-core";
export { reactRoot as reactRoot } from "@onefront/forrestjs-react-root";
export { serviceVapor } from "./service-vapor";
export { serviceAxios } from "./service-axios";
export { serviceAuth, AuthProvider } from "./service-auth";
export { serviceRest } from "./service-rest";
export {
  serviceLayout,
  LayoutProvider,
  LayoutContext,
  MenuProvider
} from "./service-layout";
export { serviceAppSwitch } from "./service-app-switch";
export { serviceEmbed } from "./service-embed";
export { default as gql } from "graphql-tag";

export default OneFront;
